module.exports = __webpack_public_path__ + "static/media/jazz_dark_temp.bff66c23.jpg";